export default {
  tab: 9,
  enter: 13,
  arrowLeft: 37,
  arrowUp: 38,
  arrowRight: 39,
  arrowDown: 40,
  escape: 27,
};
